<template lang="html">
    <div class="wrapper">
        <div class="left">
            <div v-for="(l, index) in list" v-if="(index % 2) == 0" class="icon-wrapper">
                <img v-if="l.icon"  :src="l.icon.url" class="icon">
                <span>{{l.text}}</span>
            </div>
        </div>
        <div class="right">
            <div v-for="(l, index) in list" v-if="(index % 2) != 0" class="icon-wrapper">
                <img v-if="l.icon" :src="l.icon.url" class="icon">
                <span>{{l.text}}</span>
            </div>
        </div>
    </div>


</template>


<script>
  export default {
    name: 'IconList',
    props: {
      list: {
        type: Array,
        default: []
      }
    }
  }
</script>

<style lang="scss" scoped>
.wrapper {
    display: flex;
    padding: 14px;
    justify-content: space-between;
    .left, .right {
        width: 50%;
    }
    .icon-wrapper {
        display: flex;
        /*flex-direction: column;*/
        align-items: center;
        padding: 4px 0;
        svg {
            margin-right: 14px;
        }
    }
    .icon {
        width: 24px;
        margin-right: 14px;
    }
}

</style>
